/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { Box, Typography, useTheme, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import MrRobot from '../assets/icons/MrRobot.png';
import NumberPad from './numberpad';
import DataList, { ICourse } from '../inputForm/courseDataList';
import { useEffect, useRef, useState } from 'react';
import SmartAssistantButton from './smartassistantbutton';
import { smartAbsenceCalculater } from './smartabsencecalculate';
import Typewriter from 'typewriter-effect';
import './robot.css'

interface ISmartAssistant { 
  bylaw: string;
}

const SmartAssistant: React.FC<ISmartAssistant> =  (props: ISmartAssistant) => {
  const { bylaw } = props;
  
  const [ smartAssistant, setSmartAssitant ] = useState<string>('chooseDepartment');
  const [ showDatalist, setShowDatalist ] = useState<boolean>(false);
  const [ selectedDepartment, setSelectedDepartment ] = useState<string>('');

  const selectedCourseRef = useRef<ICourse>();
  const questionRef = useRef<string>('');
  const absentLecsRef = useRef<number>(-1);
  const absentTutsRef = useRef<number>(-1);

  const departments =['BDE','CCEC','CCEE','STE','PPC','WEE','MDE','MEE','CEM','EEE','AET','SEE','AEM','IEM'];
  const oldDepartments = ['AET','SEE','IEM','MDE','MEE','CEM','EEE','HEM','CCEC','CCEE','STE','PPCC','PPCP','WEE']
  departments.sort();
  oldDepartments.sort();

  const courseCode = selectedCourseRef.current?.code.slice(0,3);
  const courseNumber = selectedCourseRef.current?.code.slice(4,7);
  const course = courseCode! + courseNumber!;
  const courseCredits = selectedCourseRef.current?.credits;
  const OddGENsCourse = ["GEN341","GEN342","GEN004","GEN333", "GENS442", "GENS341"];
  const noAbsenceCourses = ["481","482","281","381", "480"];


  const theme = useTheme();

  const onNumPadClick = (number: number) => {
    if (smartAssistant === 'numberPadClickedOnce') {
      setSmartAssitant('numberPadClickedTwice')
      absentTutsRef.current = number;
    } 
    else {
      setSmartAssitant('numberPadClickedOnce')
      absentLecsRef.current = number;
    } 
  }

  console.log(!noAbsenceCourses.includes(courseNumber!))
  
  const showSuggestedQuestions = (withEvidence?: boolean) => {
    return (
      <Box sx={{display:'flex', flexDirection: 'column', gap: '10px', justifyContent: 'space-between'}}>
        {  
          questionRef.current !== 'CanIMissNextLec' && !noAbsenceCourses.includes(courseNumber!) &&
            <SmartAssistantButton bylaw={bylaw} onClick={() => { setSmartAssitant('CanIMissNextLec'); questionRef.current = 'CanIMissNextLec'}}> 
              Can I miss next lecture ?
            </SmartAssistantButton>
        }
        {
          questionRef.current !== 'CanIMissNextTut' && 
          !(
            (courseCredits === 1 ||
            (courseCredits === 2 && courseCode === "GEN"))  && !OddGENsCourse.includes(course) ||
            noAbsenceCourses.includes(courseNumber!) 
          ) &&
            <SmartAssistantButton bylaw={bylaw} onClick={() => { setSmartAssitant('CanIMissNextTut'); questionRef.current = 'CanIMissNextTut'}}>
              Can I miss next tutorial ?
            </SmartAssistantButton>
        }
        {
          questionRef.current !== 'CanIMissNextLecTut' &&
          !(
            (courseCredits === 1 || 
            (courseCredits === 2 && courseCode === "GEN"))  && !OddGENsCourse.includes(course) && !noAbsenceCourses.includes(courseNumber!) || 
            noAbsenceCourses.includes(courseNumber!)
          ) &&
            <SmartAssistantButton bylaw={bylaw} onClick={() => { setSmartAssitant('CanIMissNextLecTut'); questionRef.current = 'CanIMissNextLecTut'}}> 
              Can I miss next lecture and tutorial ?
            </SmartAssistantButton>
        }
        {
          (smartAssistant !== 'courseIsChosen' || noAbsenceCourses.includes(courseNumber!)) &&
            <SmartAssistantButton bylaw={bylaw} 
              onClick={() => { 
                setSmartAssitant('chooseDepartment'); 
                setShowDatalist(false); 
                setSelectedDepartment('');
                questionRef.current = '';
                absentLecsRef.current = -1;
                absentTutsRef.current = -1;
              }}> 
              Choose another course
            </SmartAssistantButton>
        }
        {
          questionRef.current !== 'HowItWorks' && !noAbsenceCourses.includes(courseNumber!) &&
            <SmartAssistantButton bylaw={bylaw} onClick={() => { setSmartAssitant('HowItWorks'); questionRef.current = 'HowItWorks'}}> 
              How this course absence is calculated ?
            </SmartAssistantButton>
        }
      </Box>    
    )
  }

  const whatToSay = (state: string) => {
    if (state === 'chooseDepartment') 
      return 'Hey I am "Ghayeb", your smart assistant. Please select your department first.';

    else if (state === 'chooseCourse') 
      return 'Great! Now please choose the course you are searching for; So, I can help you.';

    else if (state === 'courseIsChosen' && noAbsenceCourses.includes(courseNumber!) ) return `My friend, gradution projects and industrial training courses have no absence. 
      Do you wanna miss a day in the company you have your internship in or what ?`;

    else if (state === 'courseIsChosen')  return `You have chosen ${selectedCourseRef.current?.name} course. How can I help you.`;

    else if (state === 'CanIMissNextLec' || state === 'CanIMissNextTut' || state === 'CanIMissNextLecTut') return 'How many lectures have you already missed?';

    else if (state === 'numberPadClickedOnce')  return 'How many tutorials have you already missed?';

    else if (state === 'numberPadClickedTwice') 
      return smartAbsenceCalculater(selectedCourseRef.current, absentLecsRef.current, absentTutsRef.current, questionRef.current);
    
    else if (state === 'HowItWorks')
      return smartAbsenceCalculater(selectedCourseRef.current, undefined, undefined, questionRef.current);

    else return;

  }

  const whatToShow = (state: string) => {
    if (state === 'courseIsChosen' || state === 'numberPadClickedTwice') return showSuggestedQuestions();

    else if (state === 'HowItWorks') return showSuggestedQuestions(true);

    else if (state === 'CanIMissNextLec' || state === 'CanIMissNextTut' || state === 'CanIMissNextLecTut') {
      // If user already mentioned his missed lecs and tuts fot the course, do not ask again.
      if (absentLecsRef.current !== -1 && absentTutsRef.current !== -1 ) setSmartAssitant('numberPadClickedTwice');

      // If user did not mentioned his missed lecs and tuts fot the course.
      else return <NumberPad bylaw={bylaw} onClick={onNumPadClick} />        
    }

    else if (state === 'numberPadClickedOnce') {
      // Check whether this course has a lecture or no
      if ((courseCredits === 1 || (courseCredits === 2 && courseCode === "GEN"))  && !OddGENsCourse.includes(course) ){
        absentTutsRef.current = 0;
        setSmartAssitant('numberPadClickedTwice')
      }
      else return <NumberPad bylaw={bylaw} onClick={onNumPadClick}/>      
    }
  }

  const onChooseCourse = (course: ICourse) => {
    selectedCourseRef.current = course;
    setSmartAssitant('courseIsChosen');
    setShowDatalist(false);
    questionRef.current = '';
    absentLecsRef.current = -1;
    absentTutsRef.current = -1;
  }

  const handleDepartmentSelect = (department: string) => {
    setSelectedDepartment(department);
    setSmartAssitant('chooseCourse');
  }

  useEffect(()=>{
    if (smartAssistant === 'chooseCourse') {
      setTimeout(()=> {
        setShowDatalist(true)
      }, 70)
    }
  },[smartAssistant])


  return (
    <Box sx={{display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px'}}>
      <Box 
        sx={{
          minHeight: '200px', 
          display:'flex', 
          background: theme.palette.common.black,
          paddingBottom: '10px',
          marginTop: '15px',
          borderRadius: '15px',
          color: theme.palette.common.white, 
          flexWrap:'wrap',
          width: '800px',
          '@media screen and (max-width: 768px)': { flexDirection: 'column', alignItems: 'center', width: 'auto'}
        }}> 
        <Box
          component={'img'}
          src={MrRobot} 
          onClick={() => setSmartAssitant('chooseDepartment')}
          width={150} 
          height={190} 
          sx={{
            cursor: 'pointer',
            width: '150px',
            height: '190px',
            animation: 'fadeShadow 3s infinite alternate',
            '@media screen and (max-width: 768px)': { width: '100px', height: '127px', position: 'relative', top: '-15px' }
          }} 
        />
      
        {
          smartAssistant === 'chooseDepartment' ?
            <Box sx={{display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px'}}>
              <Box 
                sx={{
                  fontWeight: 100, 
                  marginBottom: '10px', 
                  fontSize: '20px',
                  width: '600px',
                  padding: '10px',
                  fontFamily: 'Oswald',
                  boxSizing: 'border-box',
                  '@media screen and (max-width: 768px)': { width: '350px'}
                }}>
                <Typewriter
                  options={{
                    strings: [`${whatToSay(smartAssistant)}`],
                    autoStart: true,
                    delay: 17,
                    deleteSpeed: 100000000,
                    loop: true,
                  }}
                />
              </Box>
              <Box sx={{ width: '90%', maxWidth: '400px'}}>
                <FormControl fullWidth>
                  <InputLabel id="department-select-label" sx={{ color: theme.palette.common.white }}>
                    Select Department
                  </InputLabel>
                  <Select
                    labelId="department-select-label"
                    id="department-select"
                    value={selectedDepartment}
                    label="Select Department"
                    onChange={(event) => handleDepartmentSelect(event.target.value as string)}
                    sx={{
                      color: theme.palette.common.white,
                      '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: theme.palette.common.white,
                      },
                      '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: theme.palette.common.white,
                      },
                      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: theme.palette.common.white,
                      },
                      '& .MuiSvgIcon-root': {
                        color: theme.palette.common.white,
                      },
                    }}
                  >
                    {(bylaw === 'New' ? departments : oldDepartments).map((dept) => (
                      <MenuItem key={dept} value={dept}>{dept}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
            </Box> 
            :
            smartAssistant === 'chooseCourse' ?
              <Box sx={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                <Box 
                  sx={{
                    fontWeight: 100, 
                    marginBottom: '10px', 
                    width: '600px',
                    fontSize: '20px',
                    padding: '10px',
                    fontFamily: 'Oswald',
                    boxSizing: 'border-box',
                    '@media screen and (max-width: 768px)': { width: '350px'}
                  }}>
                  <Typewriter
                    options={{
                      strings: [`${whatToSay(smartAssistant)}`],
                      autoStart: true,
                      delay: 17,
                      deleteSpeed: 100000000,
                      loop: true,
                    }}
                  />
                </Box>
                { 
                  showDatalist &&  
                    <DataList 
                      bylaw={bylaw}
                      department={selectedDepartment}
                      onChoose={onChooseCourse} 
                      style={{
                        width: '90%',
                        borderRadius: '4px',
                        flex: 0,
                        height: '100px',
                      }}
                    />
                }
              </Box> 
              :
              <Box 
                sx={{
                  fontWeight: 100, 
                  marginBottom: '10px', 
                  fontSize: '20px',
                  width: '600px',
                  padding: '10px',
                  fontFamily: 'Oswald',
                  boxSizing: 'border-box',
                  '@media screen and (max-width: 768px)': { width: '350px'}
                }}>
                {
                  smartAssistant && 
                  <Typewriter
                    options={{
                      strings: [`${whatToSay(smartAssistant)}`],
                      autoStart: true,
                      delay: 17,
                      deleteSpeed: 100000000,
                      loop: true,
                    }}
                  />
                }
              </Box>
        }

      </Box>
      {
        whatToShow(smartAssistant)
      }

    </Box>

  ) 
}

export default SmartAssistant;